<template>
  <!-- Main content -->
  <section class="content">
    <div class="box box-body">
      <form class="form-horizontal">
        <div class="form-group">
          <div class="col-md-2">
            <label for="">Old Password</label>
          </div>
          <div class="col-md-3">
            <input type="password" class="form-control" v-model="formData.OldPassword">
          </div>
        </div>
        <div class="form-group">
          <div class="col-md-2">
            <label for="">New Password</label>
          </div>
          <div class="col-md-3">
            <input type="password" class="form-control" v-model="formData.NewPassword">
          </div>
        </div>
        <div class="form-group">
          <div class="col-md-2">
            <label for="">Confirm New Password</label>
          </div>
          <div class="col-md-3">
            <input type="password" class="form-control" v-model="formData.ConfirmNewPassword">
          </div>
        </div>
        <button type="button" class="btn btn-primary btn-flat" @click="onChangePassword()">Change Password</button>
      </form>
    </div>
  </section>
  <!-- /.content -->
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
import store from '../../store'
// import config from '../../config'
// import moment from 'moment'
// import utilities from '../../utilities'

export default {
  name: 'ChangePassword',
  components: {
  },
  data () {
    return {
      formData: {
        UserId: 0,
        EmailAddress: '',
        OldPassword: '',
        NewPassword: '',
        ConfirmNewPassword: ''
      }
    }
  },
  computed: {
  },
  created() {
  },
  mounted () {
  },
  methods: {
    onChangePassword() {
      console.log(store.getters.user)
      // Validation
      if (!store.getters.user) {
        SweetAlert.fire('Warning', 'User data not found', 'warning')
        return
      }

      if (this.formData.OldPassword === '') {
        SweetAlert.fire('Warning', 'Old password is required', 'warning')
        return
      }

      if (this.formData.NewPassword === '') {
        SweetAlert.fire('Warning', 'New password is required', 'warning')
        return
      }

      if (this.formData.ConfirmNewPassword === '') {
        SweetAlert.fire('Warning', 'Confirm new password is required', 'warning')
        return
      }

      if (this.formData.NewPassword !== this.formData.ConfirmNewPassword) {
        SweetAlert.fire('Warning', 'New password is not same', 'warning')
        return
      }

      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          this.ChangePassword()
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
        }
      })
    },
    ChangePassword() {
      var status = ''
      var message = ''
      var reqData = {
        UserId: store.getters.user ? store.getters.user.id : 0,
        EmailAddress: store.getters.user ? store.getters.user.emailAddress : '',
        OldPassword: this.formData.OldPassword,
        NewPassword: this.formData.NewPassword,
        ConfirmNewPassword: this.formData.ConfirmNewPassword
      }
      api.request('Account', 'post', '/api/Account/Password', reqData)
        .then(response => {
          console.log(response)
          status = response.data.returnStatus ? 'success' : 'error'
          message = response.data.returnMessage.join('<br>')

          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?5f61b260